import {Base} from '../../common/model/base.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {TranslateService} from '@ngx-translate/core';

export class Fascia extends Base {

  constructor(protected id: number,
              public descr: string,
              public sigla: string,
              public importoIndennita: number) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'descr', 'sigla'];
  }

  public getLabel(detailed?: Boolean) {
    return this.descr;
  }

  public toTableRow(translate?: TranslateService): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('descr', new TableRowValue(this.descr, null));
    rowValues.set('sigla', new TableRowValue(this.sigla, null));
    return new TableRow(this, rowValues);
  }

}
